import { DateTime } from 'luxon'

import SeriesQ from '@/queries/SeriesQ'
import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'

import type { SeriesStreakItem } from '@/components/Series/SeriesStreakBar/internal/types'

export default function getSeriesStreakItems({
  series,
  userId,
}: {
  series: Query
  userId: number
}): SeriesStreakItem[] {
  return series.many(SeriesQ.getSessions()).map(session => ({
    attended: session(SessionQ.didUserAttemptJoining(userId)) ?? false,
    attendanceRequired: session(SessionQ.isAttendanceRequired()) ?? false,
    startDate: DateTime.fromISO(session(SessionQ.start_date) ?? ''),
    hasEnded: session(SessionQ.hasEnded()) ?? false,
  }))
}
